import { gql } from "@/__generated__/gql";

export const CREATE_INVITATION_MUTATION = gql(`
 mutation CreateInvitation(
  $email: String!
  $firstName: String!
  $lastName: String!
  $organizationId: ID!
  $phoneNumber: String!
  $role: DashInviteRoleEnum!
) {
  createDashInviteMutation(input: {
    email: $email,
    firstName: $firstName,
    lastName: $lastName,
    organizationId: $organizationId,
    phoneNumber: $phoneNumber,
    role: $role
  }) {
    messages {
      title
      message
    }
    errors {
      title
      message
    }
  }
}
`);
